import { sleep } from '@ipfabric/ui-components/utils/sleep';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

/**
 * Show progress indicator when possibly long render is expected
 *
 * Usage:
 * ```
 * await commands.indicateLongRender();
 * // now synchronously perform the complex update of PIXI stage
 * ```
 *
 * Implementation explanation:
 * `longRendering` flag is reset as soon as next frame is successfully rendered. However:
 * - We cannot start updating the scene without sleeping since React won't make to apply state update
 *   and show the loader.
 * - If we sleep, another requested render may take place, resetting longRendering to false.
 * Therefore we need a flag `longRenderingLocked` that prevents finished render from resetting longRendering.
 */
export const indicateLongRender: GraphCommandFactory =
  (cmdContext) => async () => {
    cmdContext.updateState((draft) => {
      draft.longRendering = true;
      draft.longRenderingLocked = true;
    });
    await sleep(0);
    cmdContext.updateState((draft) => {
      draft.longRenderingLocked = false;
    });
  };
